import React from 'react';

export const FundersTableColumn = (props) => {
    const {
        CustomData,
        Value,
        AddToSearch:addToSearch = (text) => {}
    } = props;

    if(!Value) {
        return null;
    }
    
    return <div className="tag-container">
        {
            Value.map(x => (
                <span className="funder-tag"
                  onClick={() => addToSearch(x.name)}
                      key={x.funderId}
                >
                    {x.name}
                </span>
            ))
        }
    </div>;
};
